var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',[_vm._v(" "+_vm._s(_vm.texteFooter)+" | "),_c('a',{attrs:{"href":"#top"}},[_vm._v("Haut")])])])}
var staticRenderFns = []

export { render, staticRenderFns }